import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Carrera } from '../../models/observacion';
import { ActivatedRoute, Params } from '@angular/router';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-card-overlay2',
  templateUrl: './card-overlay2.component.html',
  styleUrls: ['./card-overlay2.component.scss']
})
export class CardOverlay2Component implements OnInit {
  @Input() carrera: Carrera
  @Input() borde: boolean = false
  language: any
  @Input() detalleCurso: boolean = true
  constructor(private aRouter: ActivatedRoute) {
    this.aRouter.params.forEach((params: Params) => {
      this.language = (params['language']) ? params['language'] : 'es';
    });
  }
   redirect(c) {
    if (c.route) {
      window.open(this.language + c.route, '_blank');
    } else if (c.linkCareer) {
      window.open(this.language + c.linkCareer, '_blank');
    }
  }
  createLink(item) {
    let url = environment.apiUrl + item
    return url
  }

  formatearFecha(value: any): any {
    console.log(value)
    // 1. Verificamos la condición del curso asincrónico
    if (value.modalidad === "Virtual - Asincrónico" || value.modalidad === "Virtual - Asincr\u00f3nico") {
      return "Asincrónico";
    }

    // 2. El resto de la lógica para formatear fechas
    if (value && value.inicio && value.inicio.date) {
      const date = new Date(value.inicio.date);
      const monthNames = [
      "enero", "febrero", "marzo",
      "abril", "mayo", "junio", "julio",
      "agosto", "septiembre", "octubre",
      "noviembre", "diciembre"
    ];
      const day = date.getDate();
      const monthIndex = date.getMonth();
      const monthName = monthNames[monthIndex];
      return `${day} de ${monthName}`;
    } else {
      return 'CONSULTAR';
    }
  }
  currentImgSrc: string;
  imgLoaded = false;

  ngOnInit() {
    const path = this.carrera?.pathCard || this.carrera?.pathMobile;
    const fallback = '../../../../assets/img/continua-fichas_mobile.png';

    const img = new Image();
    img.onload = () => {
      this.currentImgSrc = img.src;
      this.imgLoaded = true;
    };
    img.onerror = () => {
      this.currentImgSrc = fallback;
      this.imgLoaded = true;
    };
    img.src = path;
  }
  @HostListener('window:resize', ['$event'])

  cortarTitulo(): string {
    let height = window.innerWidth;

    // let maxLength =  (height > 768) ? 100 : 70 ;
    let titulo = this.carrera.title;
    if (!titulo) return '';
    //  if (titulo.length <= maxLength) {
    return titulo;
    /*} else {
      return titulo.substring(0, maxLength) + '...';
    }*/
  }
}

